import React, { useState, useEffect } from "react";
import { loadScoresFromLocal, saveScoresToLocal } from "../scores";
import "../styles.css";
import { OpenBooster, getCardImages } from "../helpers";
import EmptyCard from "../images/CardCollection/emptyCard.png";
import Booster1 from "../images/boosters/booster1.png";
import Booster2 from "../images/boosters/booster2.png";
import Booster3 from "../images/boosters/booster3.png";

export default function OpenBoosters() {
  const cardImages = getCardImages();
  const [boosterPrices] = useState({
    1: 10, // Price of booster 1
    2: 10, // Price of booster 2
    3: 10
  });
  const [userScores, setUserScores] = useState(loadScoresFromLocal());
  const [canOpenBooster, setCanOpenBooster] = useState({
    1: userScores >= boosterPrices[1],
    2: userScores >= boosterPrices[2],
    3: userScores >= boosterPrices[3],
  });
  const [droppedCardImage, setDroppedCardImage] = useState(null);
  const [openedBoosterIndex, setOpenedBoosterIndex] = useState(null); // Track opened booster

  useEffect(() => {
    setCanOpenBooster({
      1: userScores >= boosterPrices[1],
      2: userScores >= boosterPrices[2],
      // 3: userScores >= boosterPrices[3],
      3: false
    });
  }, [userScores, boosterPrices]);

  const handleOpenBooster = (boosterIndex) => {
    if (canOpenBooster[boosterIndex]) {
      const updatedScores = userScores - boosterPrices[boosterIndex];
      setUserScores(updatedScores);
      saveScoresToLocal(updatedScores);
      const droppedCardIndex = OpenBooster(boosterIndex) - 1;
      setDroppedCardImage(cardImages[droppedCardIndex]);
      setOpenedBoosterIndex(boosterIndex); // Set opened booster index
    } else {
      alert("You don't have enough scores to open this booster.");
    }
  };

  return (
    <div className="boosters-page">
      <div>
        <div className="booster-h1">
          You have {userScores} scores to Open Boosters
        </div>
        {droppedCardImage ? (
          <div className="dropped-card">
            <img src={require(`../images/CardCollection/${droppedCardImage}`)} alt="Dropped Card" />
          </div>
        ) : (
          <div className="dropped-card">
            <img src={EmptyCard} alt="Empty Card" />
          </div>
        )}
      </div>

      <div className="boosters">
        {/* Images with prices */}
        <div className={`booster-container ${openedBoosterIndex === 1 ? 'open-animation' : ''}`}>
          <div>
            <img src={Booster1} alt="Booster 1" onClick={() => handleOpenBooster(1)} disabled={!canOpenBooster[1]} />
            <p>{boosterPrices[1]} scores</p>
          </div>
        </div>
        <div className={`booster-container ${openedBoosterIndex === 2 ? 'open-animation' : ''}`}>
          <div>
            <img src={Booster2} alt="Booster 2" onClick={() => handleOpenBooster(2)} disabled={!canOpenBooster[2]} />
            <p>{boosterPrices[2]} scores</p>
          </div>
        </div>
        <div className={`booster-container ${openedBoosterIndex === 3 ? 'open-animation' : ''}`}>
          <div>
            <img src={Booster3} alt="Booster 3" onClick={() => handleOpenBooster(3)} disabled={!canOpenBooster[3]} />
            {/* <p>{boosterPrices[3]} scores</p> */}
            <p>This booster is currently WIP and locked</p>
          </div>
        </div>
      </div>
    </div>
  );
}
